import { isOfflineRecordRevision } from './offline-queue'

/** A conditional write needs a versioned reply, never a later refetch. */
export function assertTaskWriteAcknowledgement(
  task: unknown,
  taskId: string,
  expectedRevision: unknown,
): void {
  if (expectedRevision === undefined) return
  if (
    !isOfflineRecordRevision(expectedRevision) ||
    !task ||
    typeof task !== 'object' ||
    !('id' in task) ||
    task.id !== taskId ||
    !('revision' in task) ||
    !isOfflineRecordRevision(task.revision) ||
    task.revision <= expectedRevision
  ) {
    // The server may have committed. No status code: the offline runner must
    // retain an unknown outcome instead of interpreting this as a rejection.
    throw new Error(
      'This task change could not be confirmed. Reload the task and check its status before making another change.',
    )
  }
}

/** Missing/legacy revisions are not proof of ordering; never invent a version. */
export function isOlderRecordRevision(
  current: unknown,
  incoming: unknown,
): boolean {
  return (
    isOfflineRecordRevision(current) &&
    isOfflineRecordRevision(incoming) &&
    incoming < current
  )
}
